export const TIBOX_LINK = "https://tickets.tibox.me/forum-pro-sintez-biznes-40";
export const FACEBOOK_LINK = "https://www.facebook.com/prosyntez";
export const INSTAGRAM_LINK =
  "https://www.instagram.com/pro_syntez?fbclid=IwY2xjawGMTk5leHRuA2FlbQIxMAABHUCnrWtenV9hvi_Gwug6N95LNyZ-2KB3CTX67Lf1mz_L-XpXF1pjHfjJsA_aem_jyn9z80QiAVNm2VhxMrpmQ";
export const TELEGRAM_LINK = "https://t.me/pab_event";

export const MAP_OF_SHELTERS =
  "https://www.google.com/maps/d/u/0/viewer?mid=10wBVAAKCTHdPXYODiUbhjTTrJoY&amp%3Bll=49.60204310930155%2C34.54944381904308&amp%3Bz=12&ll=49.582588467960605%2C34.556582410545154&z=17";
